/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect } from "react";
import {
  I2cInput,
  I2cRadioButton,
  I2cRadioGroup,
} from "@webcomponents/i2cwebcomponents/dist/react";

import "../Prepaid.scss";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { emailAdressValidator } from "../../../Utils/stringUtls";
const CardPrinter = ({
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => {
  const validationSchema = Yup.object({
    of_cpfh_company_name: Yup.string().optional(),
    of_cpfh_name: Yup.string().optional(),
    of_cpfh_desk: Yup.string().optional(),
    // of_cpfh_email: Yup.string().optional(),
    of_cpfh_email: Yup.string().test("email", " ", (value) => {
      if (!value) return true;
      return emailAdressValidator(value);
    }),
    of_cpfh_card_manufacturer: Yup.string().optional(),
    of_cpfh_other_networks: Yup.string().optional(),
  });

  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "all",
    defaultValues: {
      of_cpfh_company_name: "",
      of_cpfh_name: "",
      of_cpfh_desk: "",
      of_cpfh_email: "",
      of_cpfh_card_manufacturer: "n/a",
      of_cpfh_other_networks: "",
    },
  });

  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;

  const fields = [
    "of_cpfh_company_name",
    "of_cpfh_name",
    "of_cpfh_desk",
    "of_cpfh_email",
    "of_cpfh_card_manufacturer",
    "of_cpfh_other_networks",
  ];
  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      fields.forEach((field) => {
        methods.setValue(field, formDataJson[2]["2_1"][field] ?? "");
      });
      methods.trigger();
    }
  }, [isFetching]);

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);
  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      2: {
        ...addFormData["2"],
        "2_1": { ...values },
      },
    });
  };

  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("2_1", true);
    else setFormValidStates("2_1", false);
  }, [Object.keys(errors).length]);
  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-column-sm gap-row-sm" className="section-space">
          <div i2c-grid="4@md">
            <div className="single-field-wrapper">
              <Controller
                name="of_cpfh_company_name"
                control={control}
                render={({ field }) => (
                  <I2cInput
                    {...field}
                    className="single-input-field"
                    onI2cInput={(e) => {
                      const value = e.target.value;
                      field.onChange(value);
                      handleValueChanges();
                    }}
                    size="large"
                    label="Company"
                    placeholder="Enter Company"
                    name={"of_cpfh_company_name"}
                  />
                )}
              />
              <ErrorMessage
                show={
                  errors.of_cpfh_company_name &&
                  methods.formState.touchedFields.of_cpfh_company_name
                    ? true
                    : false
                }
                message={
                  errors.of_cpfh_company_name?.message ?? "Invalid input"
                }
              />
            </div>
          </div>
          <div i2c-grid="4@md">
            <div className="single-field-wrapper">
              <Controller
                name="of_cpfh_name"
                control={control}
                render={({ field }) => (
                  <I2cInput
                    {...field}
                    className="single-input-field"
                    onI2cInput={(e) => {
                      const value = e.target.value;
                      field.onChange(value);
                      handleValueChanges();
                    }}
                    size="large"
                    label="Name"
                    placeholder="Enter Name"
                    name={"of_cpfh_name"}
                  />
                )}
              />
              <ErrorMessage
                show={
                  errors.of_cpfh_name &&
                  methods.formState.touchedFields.of_cpfh_name
                    ? true
                    : false
                }
                message={errors.of_cpfh_name?.message ?? "Invalid input"}
              />
            </div>
          </div>
          <div i2c-grid="4@md">
            <div className="single-field-wrapper">
              <Controller
                name="of_cpfh_desk"
                control={control}
                render={({ field }) => (
                  <I2cInput
                    {...field}
                    className="single-input-field"
                    onI2cInput={(e) => {
                      const value = e.target.value;
                      field.onChange(value);
                      handleValueChanges();
                    }}
                    size="large"
                    label="Desk"
                    placeholder="Enter Desk"
                    name={"of_cpfh_desk"}
                  />
                )}
              />
              <ErrorMessage
                show={
                  errors.of_cpfh_desk &&
                  methods.formState.touchedFields.of_cpfh_desk
                    ? true
                    : false
                }
                message={errors.of_cpfh_desk?.message ?? "Invalid input"}
              />
            </div>
          </div>
          <div i2c-grid="4@md">
            <div className="single-field-wrapper">
              <Controller
                name="of_cpfh_email"
                control={control}
                render={({ field }) => (
                  <I2cInput
                    {...field}
                    className="single-input-field"
                    onI2cInput={(e) => {
                      const value = e.target.value;
                      field.onChange(value);
                      handleValueChanges();
                    }}
                    size="large"
                    label="Email"
                    placeholder="Enter Email"
                    type="email"
                    name={"of_cpfh_email"}
                  />
                )}
              />
              <ErrorMessage
                show={
                  errors.of_cpfh_email &&
                  methods.formState.touchedFields.of_cpfh_email
                    ? true
                    : false
                }
                message={errors.of_cpfh_email?.message ?? "Invalid input"}
              />
            </div>
          </div>
        </div>
        <div className="section-space">
          <div className="sub-heading mb-16">
            Card Manufacturer – PCI compliant
          </div>
          <div className="single-field-wrapper">
            <Controller
              name="of_cpfh_card_manufacturer"
              control={control}
              render={({ field }) => (
                <I2cRadioGroup
                  value={methods.watch("of_cpfh_card_manufacturer")}
                  {...field}
                  name="of_cpfh_card_manufacturer"
                  onI2cChange={(e) => {
                    field.onChange(e);
                    handleValueChanges();
                  }}
                >
                  {["Yes", "No","N/A"].map((radio, index) => (
                    <I2cRadioButton
                      key={index}
                      value={radio.toLocaleLowerCase()}
                    >
                      {radio}
                    </I2cRadioButton>
                  ))}
                </I2cRadioGroup>
              )}
            />
          </div>
        </div>
        <div i2c-grid="grid gap-sm" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading mb-4">
              Other Networks/Vendor Integrations
            </div>
            <div className="custom-label-light">
              Any other 3rd party not mentioned in the list
            </div>
          </div>
          <div i2c-grid="4@md">
            <div className="single-field-wrapper">
              <Controller
                name="of_cpfh_other_networks"
                control={control}
                render={({ field }) => (
                  <I2cInput
                    {...field}
                    className="single-input-field"
                    onI2cInput={(e) => {
                      const value = e.target.value;
                      field.onChange(value);
                      handleValueChanges();
                    }}
                    size="large"
                    placeholder="Enter Details"
                    name={"of_cpfh_other_networks"}
                  />
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CardPrinter;
